<template>
    <!-- график оплат -->
    <div class="object-info__inner accordion-body__inner">
        <div class="chart-payment declarer-item__inner">
            <div class="chart-payment__title h2 block title-normal-weight">График оплат на {{ nowDate | formatDateToStr }}</div>
            <div class="chart-payment__table">
                <div class="paymennt-shedule__inner object-info__section object-info__section--short">
                    <div class="request-table declarer-map-table">
                        <div class="request-table__row request-table__row--head h5 block">
                            <div class="paymennt-shedule__cell paymennt-shedule__cell--s">Дата оплаты <br>(план)</div>
                            <div class="paymennt-shedule__cell paymennt-shedule__cell--s">% от общей <br>суммы</div>
                            <div class="paymennt-shedule__cell">Сумма оплаты <br>(план), руб с НДС</div>
                            <div class="paymennt-shedule__cell">Дата оплаты <br>(факт)</div>
                            <div class="paymennt-shedule__cell">Сумма оплаты (факт), <br>руб. с НДС</div>
                            <!--
                            <div class="paymennt-shedule__cell">Пени в разрезе <br>плана</div>
                            <div class="paymennt-shedule__cell">Дата оплаты пени</div>
                            <div class="paymennt-shedule__cell">Факт оплаты Пени</div>
                            -->
                        </div>
                        <div v-for="chartrow in chartBefore" class="request-table__row paymennt-shedule__row chart-payment__row h5 block">
                            <div class="paymennt-shedule__cell paymennt-shedule__cell--s">
                                <div class="request-table__label">Дата оплаты (план)</div>
                                {{ chartrow.planDate | formatDateToStr }}
                            </div>
                            <div class="paymennt-shedule__cell paymennt-shedule__cell--s">
                                <div class="request-table__label">% от общей суммы</div>
                                {{ chartrow.planPercent | formatAmount }}
                            </div>
                            <div class="paymennt-shedule__cell">
                                <div class="request-table__label">Сумма оплаты (план), руб с НДС</div>
                                {{ chartrow.planAmount | formatAmount }}
                            </div>
                            <div class="paymennt-shedule__cell">
                                <div class="request-table__label">Дата оплаты (факт)</div>
                                <div class="chart-payment__hidden-text">
                                    {{ chartrow.factDate | formatDateToStr }}
                                </div>
                            </div>
                            <div class="paymennt-shedule__cell">
                                <div class="request-table__label">Сумма оплаты (факт), руб. с НДС</div>
                                {{ chartrow.factAmount | formatAmount }}
                            </div>
                            <!--
                            <div class="paymennt-shedule__cell">
                                <div class="request-table__label">Пени в разрезе плана</div>
                                {{ chartrow.planFineAmount | formatAmount }}
                            </div>
                            <div class="paymennt-shedule__cell">
                                <div class="request-table__label">Дата оплаты пени</div>
                                <div class="chart-payment__hidden-text">
                                    {{ chartrow.factFineDate | formatDateToStr }}
                                </div>
                            </div>
                            <div class="paymennt-shedule__cell">
                                <div class="request-table__label">Факт оплаты Пени</div>
                                {{ chartrow.pactFineAmount | formatAmount }}
                            </div>
                            -->
                        </div>
                                
                            <!--<div v-if="chartVirtualString!=null" class="request-table__row paymennt-shedule__row chart-payment__row h5 block">-->
                                <!--<div class="paymennt-shedule__cell paymennt-shedule__cell--s">
                                    <div class="request-table__label">Дата оплаты (план)</div>
                                    <span class="status-error">{{ chartVirtualString.debtDate | formatDateToStr  }}</span>
                                </div>
                                <div class="paymennt-shedule__cell paymennt-shedule__cell--s">
                                    <div class="request-table__label">% от общей суммы</div>
                                    <span class="status-error"> {{ chartVirtualString.debtAmountText }}</span>
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Сумма оплаты (план), руб с НДС</div>
                                    <span class="status-error">{{ chartVirtualString.debtAmount | formatAmount }}</span>
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Дата оплаты (факт)</div>
                                    <div class="chart-payment__hidden-text">
                                        -
                                    </div>
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Сумма оплаты (факт), руб. с НДС</div>
                                    <span class="status-error">{{ chartVirtualString.debtFineText }}</span>
                                </div>-->
                                <!--
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Пени в разрезе плана</div>
                                    <span class="status-error">{{ chartVirtualString.debtFine | formatAmount }}</span>
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Дата оплаты пени</div>
                                    <div class="chart-payment__hidden-text">
                                        -
                                    </div>
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Факт оплаты Пени</div>
                                    -
                                </div>
                                    -->
                            <!--</div>-->

                            <div v-for="chartrow in chartAfter" class="request-table__row paymennt-shedule__row chart-payment__row h5 block">
                                <div class="paymennt-shedule__cell paymennt-shedule__cell--s">
                                    <div class="request-table__label">Дата оплаты (план)</div>
                                    {{ chartrow.planDate | formatDateToStr }}
                                </div>
                                <div class="paymennt-shedule__cell paymennt-shedule__cell--s">
                                    <div class="request-table__label">% от общей суммы</div>
                                    {{ chartrow.planPercent | formatAmount }}
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Сумма оплаты (план), руб с НДС</div>
                                    {{ chartrow.planAmount | formatAmount }}
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Дата оплаты (факт)</div>
                                    <div class="chart-payment__hidden-text">
                                        {{ chartrow.factDate | formatDateToStr }}
                                    </div>
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Сумма оплаты (факт), руб. с НДС</div>
                                    {{ chartrow.factAmount | formatAmount }}
                                </div>
                                <!--
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Пени в разрезе плана</div>
                                    {{ chartrow.planFineAmount | formatAmount }}
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Дата оплаты пени</div>
                                    <div class="chart-payment__hidden-text">
                                        {{ chartrow.factFineDate | formatDateToStr }}
                                    </div>
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Факт оплаты Пени</div>
                                    {{ chartrow.pactFineAmount | formatAmount }}
                                </div>
                                    -->
                            </div>

                            <!--итоговые строки-->
                            <div v-if="chartResult!=null" class="request-table__row paymennt-shedule__row chart-payment__row h5 block is-weight">
                                <div class="paymennt-shedule__cell paymennt-shedule__cell--s">
                                    <div class="request-table__label">Дата оплаты (план)</div>
                                    {{ chartResult.resultPlanText }}
                                </div>
                                <div class="paymennt-shedule__cell paymennt-shedule__cell--s">
                                    <div class="request-table__label">% от общей суммы</div>
                                    {{ chartResult.resultPlanPercent| formatAmount }}
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Сумма оплаты (план), руб с НДС</div>
                                    {{ chartResult.resultPlanAmount | formatAmount }}
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Дата оплаты (факт)</div>
                                    <div class="chart-payment__hidden-text">
                                        -
                                    </div>
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Сумма оплаты (факт), руб. с НДС</div>
                                    -
                                </div>
                                <!--
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Пени в разрезе плана</div>
                                    {{ chartResult.ResultPlanFine | formatAmount }}
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Дата оплаты пени</div>
                                    <div class="chart-payment__hidden-text">
                                        -
                                    </div>
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Факт оплаты Пени</div>
                                    -
                                </div>
                                -->
                            </div>

                            <div v-if="chartResult!=null" class="request-table__row paymennt-shedule__row chart-payment__row h5 block is-weight">
                                <div class="paymennt-shedule__cell paymennt-shedule__cell--s">
                                    <div class="request-table__label">Дата оплаты (план)</div>
                                    {{ chartResult.resultFactText }}
                                </div>
                                <div class="paymennt-shedule__cell paymennt-shedule__cell--s">
                                    <div class="request-table__label">% от общей суммы</div>
                                    {{ chartResult.resultFactPercent | formatAmount}}
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Сумма оплаты (план), руб с НДС</div>
                                    -
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Дата оплаты (факт)</div>
                                    <div class="chart-payment__hidden-text">
                                        -
                                    </div>
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Сумма оплаты (факт), руб. с НДС</div>
                                    {{ chartResult.resultFactAmount | formatAmount}}
                                </div>
                                <!--
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Пени в разрезе плана</div>
                                    -
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Дата оплаты пени</div>
                                    <div class="chart-payment__hidden-text">
                                        -
                                    </div>
                                </div>
                                <div class="paymennt-shedule__cell">
                                    <div class="request-table__label">Факт оплаты Пени</div>
                                    {{ chartResult.resultFactFine| formatAmount }}
                                </div>
                                    -->
                            </div>

                        </div>
                </div>
            </div>
        </div>
        <div class="chart-payment__description block">
            <div class="chart-payment__description-item">
                <h5 class="h5">Уважаемый заявитель! При расчетах по договору обязательно указывайте в назначении платежа:</h5>
                <p>
                    “Оплата по договору № <a href="" class="link status-primary">
                        {{ pact.number }}
                    </a> от {{pact.date | formatDate }} за...”
                </p>
            </div>
            <!--<div class="chart-payment__description-item">
                <h5 class="h5">Реквизиты получателя платежа:</h5>
                <p class="">Акционерное общество “Сибирская энергетическая компания”</p>
                <p class="">ИНН: 5405270340</p>
                <p class="">КПП: 775050001</p>
                <p class="">ОГРН: 1045401912401</p>
                <p class="">Расчетный счет: 407028109002900009683</p>
            </div>-->
            <div class="chart-payment__description-item">
                <h5 class="h5">Способы оплаты:</h5>
                <p class="">1. В любом банке по реквизитам</p>
                <p class="">2. Система “Клиент-банк”</p>
                <p class="">3. Банковской картой на нашем <a href="" class="link status-primary">сайте</a> (сервис доступен только для физических лиц)</p>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    Vue.config.devtools = true;

    import Vue from 'vue'
    import Vuelidate from 'vuelidate'

    Vue.use(Vuelidate);

    Vue.filter('RUB', function (value) {
        if (value === null || isNaN(value))
            return '0';
        return Number(value).toLocaleString('ru-RU', { style: 'currency', currency: 'RUB' });
    });

    export default {
        components: {
   
        },

		props: ['pact'],

        data() {
            return {
                chart: [],
                chartBefore: [],
                chartAfter: [],
                chartVirtualString: {},
				chartResult: {},
				nowDate: new Date(),

            };
        },
        computed: {

            filteredTuGroup: function () {
                if (this.filterText.length < this.signCountToStartFilter)
                    return this.tuGroup;

                var filterResult = this.filterByAddress();

                return Object.keys(filterResult).length > 0 ? filterResult : this.filterByAccountAndDeviceNumbers();
            }
        },
        mounted() {
			this.getPaymentChart();

        },
        filters: {
            f4(value) {
                return value;//.toFixed(4);
            },
            ruF2(number) {
                if (number === null) return 0;
                return number.toLocaleString('ru-RU');
            },
            formatDate(value) {
                if (value) {
                    return value.substring(8, 10) + "." + value.substring(5, 7) + "." + value.substring(0, 4);
                }
            },
            formatTarif(value) {
                var digitsValue = parseFloat(value);
                if (digitsValue) {
                    if (digitsValue == 0) {
                        return '-'
                    }
                    else { 
                        return digitsValue.toFixed(2);
                    }
                }
                else return '-';
            },

            formatDateToStr: function (dateValue) {
                //format date
                if (dateValue !== null && dateValue !== undefined) {
                    return moment(dateValue).format('DD.MM.YYYY');
                }
                return "-";
            },

            formatAmount: function (value) {
                if (value) {
                    //var formatCalc = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
                    //               return formatCalc;
                    // return Number(value).toLocaleString('ru-RU', { style: 'currency', currency: 'RUB' });
                    return Number(value).toLocaleString('ru-RU', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
                }
                else {
                    return "-";
                }
            }
        },

        methods: {

			formatStrToDate: function (strValue) {
				var year = Number(strValue.split(".")[2]);
				var month = Number(strValue.split(".")[1]) - 1;
				var day = Number(strValue.split(".")[0]);
				return new Date(year, month, day);
            },

            //formatDate: function (value) {
            //    if (value) {
            //        return value.substring(8, 10) + "." + value.substring(5, 7) + "." + value.substring(0, 4);
            //    }
            //},


            dateToJsDate: function (date) {
                var jsDate = new Date();
                if (date) {
                    var strDate = this.formatDate(date);
                    if (strDate) {
                        jsDate = this.formatStrToDate(strDate);
                    }
                    return jsDate;
                }

            },

			getPaymentChart: function () {
                var self = this;

              //  console.log(this.pact);

				axios.get('/STS/Declarer/GetPaymentChart', {
					params: {
						pactId: self.pact.id
					}
				})
					.then(function (response) {

                        self.chartBefore = response.data.paymentScheduleBefore;
						self.chartAfter = response.data.paymentScheduleAfter;
                        self.chartVirtualString = response.data.paymentVirtual;
                        self.chartResult = response.data.paymentResult;

      //                  console.log('chartBefore:' + self.chartBefore);
						//console.log('chartAfter:' + self.chartAfter);
						//console.log('chartVirtualString:' + self.chartVirtualString);
						//console.log('chartResult:' + self.chartResult);

					})
					.catch(function (error) {
						console.log('Ошибка получения данных: ' + error.message);
					});
			},
  
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// Scripts/app/sts/declarers/declarer/PaymentChart.vue